export default (page) => `/${page.uid}`
